import styled from 'styled-components'
import { Colors, Spacing } from 'cio-design-library/design-tokens'
import Typography from 'builder/styles/typography'
import Media from 'builder/styles/media'
import { Icon20 } from 'builder/components/Icon'

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  overflow: hidden;
  background-color: ${Colors.White};
  border-radius: 16px;
  z-index: 30;
  padding: ${Spacing.L};
  gap: ${Spacing.M};

  ${Media.Phone`
    padding: 0px 20px 24px 20px;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  `}
`

export const CloseIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  top: 48px;
  right: 48px;

  ${Media.Phone`
    top: 5px;
    right: 5px;
  `}
`

export const CloseIcon = styled(Icon20.Close)`
  ${Media.AbovePhone`
  color: ${Colors.Neutral50};
  border-radius: 28px;
  width: 28px;
  height: 28px;
  padding: 4px;
  background: ${Colors.Neutral10};

  &:hover {
    background: ${Colors.Blue10};
    color: ${Colors.Blue50};
  }
  
  `};
`

export const Header = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  gap: ${Spacing['2XS']};

  ${Media.Phone`
    gap: ${Spacing['3XS']};
  `};
`

export const Title = styled.p`
  ${Typography.S};
  font-weight: 600;
  color: ${Colors.Neutral90};
`

export const SubTitle = styled.p`
  ${Typography.Body};
  text-align: center;
  color: ${Colors.Neutral50};
`

export const HeaderLineContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Line = styled.div`
  width: 25px;
  height: 4px;
  border-radius: 4px;
  background: ${Colors.Neutral30};
  margin: 8px auto 12px auto;

  ${Media.AbovePhone`display: none`}
`
